// import logo from './logo.svg';
import React, { useState } from 'react'
import './App.css';
import Navbar from './components/Navigation/Navbar';
import { Link } from 'react-scroll';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import Modal from 'react-modal';

// import { Pannellum } from "pannellum-react";
import banner from './assets/banner.mp4'
import velux from './assets/velux.png'
import build from './assets/build.jpg'
import trade from './assets/trade.jpg'
import manage from './assets/manage.jpg'
import about from './assets/ds-01.jpg'
import design from './assets/design.jpg'

import velux0 from './assets/Velux/0.jpg'
import velux1 from './assets/Velux/1.jpg'
import velux2 from './assets/Velux/2.jpg'
import velux3 from './assets/Velux/3.jpg'
import velux4 from './assets/Velux/4.jpg'
import velux5 from './assets/Velux/5.jpg'
import velux6 from './assets/Velux/6.jpg'

import condo0 from './assets/Condo/0.jpg'
import condo1 from './assets/Condo/1.jpg'
import condo2 from './assets/Condo/2.jpg'
import condo3 from './assets/Condo/3.jpg'
import condo4 from './assets/Condo/4.jpg'
import condo5 from './assets/Condo/5.jpg'
import condo6 from './assets/Condo/6.jpg'
import condo7 from './assets/Condo/7.jpg'
import condo8 from './assets/Condo/8.jpg'
import condo9 from './assets/Condo/9.jpg'
import condo10 from './assets/Condo/10.jpg'
import condo11 from './assets/Condo/11.jpg'
import condo12 from './assets/Condo/12.jpg'
import condo13 from './assets/Condo/13.jpg'
import condo14 from './assets/Condo/14.jpg'
import condo15 from './assets/Condo/15.jpg'
import condo16 from './assets/Condo/16.jpg'
import condo17 from './assets/Condo/17.jpg'
import condo18 from './assets/Condo/18.jpg'
import condo19 from './assets/Condo/19.jpg'
import condo20 from './assets/Condo/20.jpg'

import imus0 from './assets/Imus/0.jpg'
import imus1 from './assets/Imus/1.jpg'
import imus2 from './assets/Imus/2.jpg'
import imus3 from './assets/Imus/3.jpg'

import signal0 from './assets/Signal/0.jpg'
import signal1 from './assets/Signal/1.jpg'
import signal2 from './assets/Signal/2.jpg'
import signal3 from './assets/Signal/3.jpg'
import signal4 from './assets/Signal/4.jpg'
import signal5 from './assets/Signal/5.jpg'
import signal6 from './assets/Signal/6.jpg'
import signal7 from './assets/Signal/7.jpg'
import signal8 from './assets/Signal/8.jpg'
import signal9 from './assets/Signal/9.jpg'

import cuneca0 from './assets/Cuenca/0.jpeg'
import cuneca1 from './assets/Cuenca/1.jpg'
import cuneca2 from './assets/Cuenca/2.jpg'
import cuneca3 from './assets/Cuenca/3.jpg'
import cuneca4 from './assets/Cuenca/4.jpg'
import cuneca5 from './assets/Cuenca/5.jpg'
import cuneca6 from './assets/Cuenca/6.jpg'
import cuneca7 from './assets/Cuenca/7.jpg'
import cuneca8 from './assets/Cuenca/8.jpg'
import cuneca9 from './assets/Cuenca/9.jpg'

import pinagsama0 from './assets/Pinagsama/0.jpg'
import pinagsama1 from './assets/Pinagsama/1.jpg'
import pinagsama2 from './assets/Pinagsama/2.jpg'
import pinagsama3 from './assets/Pinagsama/3.jpg'
import pinagsama4 from './assets/Pinagsama/4.jpg'
import pinagsama5 from './assets/Pinagsama/5.jpg'
import pinagsama6 from './assets/Pinagsama/6.jpg'
import pinagsama7 from './assets/Pinagsama/7.jpg'

import oton0 from './assets/Oton/0.jpg'
import oton1 from './assets/Oton/1.jpg'
import oton2 from './assets/Oton/2.jpg'
import oton3 from './assets/Oton/3.jpg'
import oton4 from './assets/Oton/4.jpg'
import oton5 from './assets/Oton/5.jpg'
import oton6 from './assets/Oton/6.jpg'
import oton7 from './assets/Oton/7.jpg'
import oton8 from './assets/Oton/8.jpg'
import oton9 from './assets/Oton/9.jpg'
import oton10 from './assets/Oton/10.jpg'

import marikina0 from './assets/Marikina/0.jpg'
import marikina1 from './assets/Marikina/1.jpg'
import marikina2 from './assets/Marikina/2.jpg'
import marikina3 from './assets/Marikina/3.jpg'
import marikina4 from './assets/Marikina/4.jpg'
import marikina5 from './assets/Marikina/5.jpg'

import pacific0 from './assets/PacificStar/0.jpg'
import pacific1 from './assets/PacificStar/1.jpg'
import pacific2 from './assets/PacificStar/2.jpg'
import pacific3 from './assets/PacificStar/3.jpg'
import pacific4 from './assets/PacificStar/4.jpg'
import pacific5 from './assets/PacificStar/5.jpg'

import pque0 from './assets/Paranaque/0.jpg'
import pque1 from './assets/Paranaque/1.jpg'
import pque2 from './assets/Paranaque/2.jpg'
import pque3 from './assets/Paranaque/3.jpg'
import pque4 from './assets/Paranaque/4.jpg'
import pque5 from './assets/Paranaque/5.jpg'
import pque6 from './assets/Paranaque/6.jpg'

import photoStudio0 from './assets/PhotoStudio/0.jpg'
import photoStudio1 from './assets/PhotoStudio/1.jpg'
import photoStudio2 from './assets/PhotoStudio/2.jpg'
import photoStudio3 from './assets/PhotoStudio/3.jpg'
import photoStudio4 from './assets/PhotoStudio/4.jpg'
import photoStudio5 from './assets/PhotoStudio/5.jpg'

import QC0 from './assets/QC/0.jpg'
import QC1 from './assets/QC/1.jpg'
import QC2 from './assets/QC/2.jpg'
import QC3 from './assets/QC/3.jpg'
import QC4 from './assets/QC/4.jpg'
import QC5 from './assets/QC/5.jpg'

import RCBC0 from './assets/RCBC/0.jpg'
import RCBC1 from './assets/RCBC/1.jpg'
import RCBC2 from './assets/RCBC/2.jpg'
import RCBC3 from './assets/RCBC/3.jpg'
import RCBC4 from './assets/RCBC/4.jpg'
import RCBC5 from './assets/RCBC/5.jpg'

import villamor0 from './assets/Villamor/0.jpg'
import villamor1 from './assets/Villamor/1.jpg'
import villamor2 from './assets/Villamor/2.jpg'
import villamor3 from './assets/Villamor/3.jpg'
import villamor4 from './assets/Villamor/4.jpg'
import villamor5 from './assets/Villamor/5.jpg'

Modal.setAppElement('#root')

function App() {

  const [images, setImages] = useState(
    { 
      subtitle: "", 
      info: "",
      thumbnail: "",
      carousel: [
        ""
      ]
    }
  )
  // console.log('IMAGES', images)

  const [gallery, setGallery] = useState([
    { 
      subtitle: "VELUX Roof Windows Installation", 
      info: "",
      thumbnail: velux0,
      carousel: [
        velux1, velux2, velux3, velux4, velux5, velux6
      ]
    },
    { 
      subtitle: "CONDOS", 
      info: "",
      thumbnail: condo0,
      carousel: [
        condo1, condo2, condo3, condo4, condo5, condo6, condo7, condo8, condo9, condo10,
        condo11, condo12, condo13, condo14, condo15, condo16, condo17, condo18, condo19, condo20
      ]
    },
    { 
      subtitle: "IMUS, CAVITE", 
      info: "Assumed construction of an unfinished 3-storey residence with roof deck in Imus, Cavite",
      thumbnail: imus0,
      carousel: [
        imus1, imus2, imus3
      ]
    },
    { 
      subtitle: "SIGNAL, TAGUIG", 
      info: "Ground-up construction of a 3-storey rental building in Signal, Taguig",
      thumbnail: signal0,
      carousel: [
        signal1, signal2, signal3, signal4, signal5, signal6, signal7, signal8, signal9
      ]
    },
    { 
      subtitle: "CUENCA, BATANGAS", 
      info: "Ground-up residential construction project in Cuenca, Batangas",
      thumbnail: cuneca0,
      carousel: [
        cuneca1, cuneca2, cuneca3, cuneca4, cuneca5, cuneca6, cuneca7, cuneca8, cuneca9
      ]
    },
    { 
      subtitle: "PINAGSAMA, TAGUIG", 
      info: "Ground-up construction of a 4-storey rental building in Pinagsama, Taguig",
      thumbnail: pinagsama0,
      carousel: [
        pinagsama1, pinagsama2, pinagsama3, pinagsama4, pinagsama5, pinagsama6, pinagsama7
      ]
    },
    { 
      subtitle: "OTON, ILOILO", 
      info: "Ground-up construction of a beach front residence in Oton, Iloilo",
      thumbnail: oton0,
      carousel: [
        oton1, oton2, oton3, oton4, oton5, oton6, oton7, oton8, oton9, oton10
      ]
    },
    { 
      subtitle: "MARIKINA CITY", 
      info: "Fit-out and renovation of a residential home in Marikina",
      thumbnail: marikina0,
      carousel: [
        marikina1,  marikina2,  marikina3,  marikina4,  marikina5
      ]
    },
    { 
      subtitle: "PACIFIC STAR", 
      info: "Office and Server area Fit-out at Pacific Star Building in Makati",
      thumbnail: pacific0,
      carousel: [
        pacific1, pacific2, pacific3, pacific4, pacific5
      ]
    },
    { 
      subtitle: "PARANAQUE", 
      info: "Ground-up construction of a 4–storey rental building in Paranaque",
      thumbnail: pque0,
      carousel: [
        pque1, pque2, pque3, pque4, pque5, pque6
      ]
    },
    { 
      subtitle: "PHOTO STUDIO", 
      info: "Epoxy painting and maintenance of a photo studio in Pasay",
      thumbnail: photoStudio0,
      carousel: [
        photoStudio1, photoStudio2, photoStudio3, photoStudio4, photoStudio5
      ]
    },
    { 
      subtitle: "APARTMENT QC", 
      info: "Repaiting and maintenance project Quezon city project",
      thumbnail: QC0,
      carousel: [
        QC1, QC2, QC3, QC4, QC5
      ]
    },
    { 
      subtitle: "RCBC", 
      info: "Reinstatement project of an out-going RCBC tenant in Makati",
      thumbnail:RCBC0,
      carousel: [
       RCBC1,RCBC2,RCBC3,RCBC4,RCBC5
      ]
    },
    { 
      subtitle: "VILLAMOR PASAY", 
      info: "Group–up Construction of a 4–storey rental building in Villamor Pasay",
      thumbnail:villamor0,
      carousel: [
       villamor1,villamor2,villamor3,villamor4,villamor5
      ]
    }
  ])

  const [modalIsOpen, setModalIsOpen] = useState(false)

  const modalStyles = {
    content : {
      height: '90%',
      top: '10%',
      backgroundColor: 'transparent',
      border: 'none'
    },
    overlay: {
      backgroundColor: '#27272733',
      backdropFilter: 'blur(15px)',
      transition: 'all 300ms'
    }
  };

  return (
    <div className="App">
      <Navbar />
      
      {/* <video className='banner' autoPlay loop muted playsInline>
        <source src={banner} type='video/mp4' />
      </video> */}

      <div className="bgImage">
        <div id="backgroundchange">
            <div className="backgroundimg" id="back1"></div>
            <div className="backgroundimg" id="back2"></div>
            <div className="backgroundimg" id="back3"></div>
            <div className="backgroundimg" id="back4"></div>
            <div className="backgroundimg" id="back5"></div>
        </div>
      </div>

      <section className="home" id="home">
        <div className="wrapper">
          <div className="slogan">
            <span>Helping you build</span>
            <span>your dreams,  <span className="yellow">better</span>.</span>
            <hr />
            <div className="cta">
              <Link 
              className="call"
              to="projects"
              smooth={true}
              offset={-70}>
                <span>View Projects</span>
              </Link>
              <span className="or">or</span>
              <Link 
              className="call"
              to="about"
              smooth={true}
              offset={-70}>
                <span>Read About Us</span>
              </Link>
          </div>
          </div>
        </div>
      </section>

      <section className="services" id="services">
        <div className="wrapper">
          <div className="title">
            <span>SERVICES</span>
            <hr />
          </div>

          <div className="grid-services">
            <div>
              <div className="wallpaper">
                <img src={design} alt="design" />
              </div>
              <span className="subtitle">Design</span>
              <article>
              Our team of designers translate your dreams of a home or commercial space into reality by incorporating your ideas or wishes into complete building plans and designs subject to existing building codes and specifications, with special emphasis on functionality and safety.
              <br/><br/>
              Our design team is a separate cost center, so we accept “design only services” for everybody.
              </article>
            </div>

            <div>
              <div className="wallpaper">
                <img src={build} alt="build" />
              </div>
              <span className="subtitle">Build</span>
              <article>
              We have a team of professionals, skilled engineers and craftsmen. Complemented with the right tools, equipment and safety gears, with an all-out purchasing, finance and administrative service support, we translate building plans and designs into an actual residential building, apartment units or commercial space of your dreams. 
              <br/><br/>
              Do refer to our list of completed projects.
              </article>
            </div>

            <div>
              <div className="wallpaper">
                <img src={trade} alt="trade" />
              </div>
              <span className="subtitle">Trade</span>
              <article>
              We know you deserve better products, do not fret, we will be selling construction materials and household products on-line by the 3rd quarter of 2021. Do check our website for this service from time to time.
              </article>
            </div>

            <div>
              <div className="wallpaper">
                <img src={manage} alt="manage" />
              </div>
              <span className="subtitle">Manage</span>
              <article>
              {/* Some texts here *** */}
              </article>
              <button className='manage'> View More Info</button>
            </div>

          </div>
        </div>
      </section>

      {/* <section className="history">
        <div className="wrapper">
          <div className="grid-history">
            <div>
              <span className="title-history">2020</span>
              <span className="subtitle-history">Year Established</span>
            </div>
            <div className="vr"></div>
            <div>
              <span className="title-history">345</span>
              <span className="subtitle-history">Projects Completed</span>
            </div>
            <div className="vr"></div>
            <div>
              <span className="title-history">700</span>
              <span className="subtitle-history">Contractors Appointed</span>
            </div>
            <div className="vr"></div>
            <div>
              <span className="title-history">320</span>
              <span className="subtitle-history">Happy Clients</span>
            </div>
          </div>
        </div>
      </section> */}

      <section className="about" id="about">
        <div className="grid-about">
          <div>
            <div className="wrapper">
              <div className="title">
                <span>ABOUT</span>
                <hr />
              </div>
              <div className="content">
                <span className="subtitle">Who We Are</span>
                <article className="article-about">
                We are a young team of designers, builders, and suppliers in the Philippines. But we aren’t like the others, we are better. 
                <br /> <br />
                Our process is fluid. Dynamic. Custom. Once we get a sense of what you need, we craft the project plan, supply and build with on-going consultations with you until the final phases. Like family or friends, we are good at listening and we’ll be with you every step of the way. 
                <br /> <br />
                We help you realize your dreams with better people, better work, and better experience. 
                </article>
                {/* <br />
                <span className="subtitle">Vision</span>
                <article className="article-about">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </article> */}
              </div>
            </div>
          </div>
          <div>
            <div className="wallpaper-about">
              <img src={about} alt="construction iamge" />
            </div>
          </div>
        </div>
      </section>
      
      <Modal 
        isOpen={modalIsOpen} 
        style={modalStyles}>
          <div className="close-modal" >
            <span className="close-modal-text" onClick={() => setModalIsOpen(false)}>Close</span>
          </div>
          <div className="carousel-container">
            <Carousel className="carousel" dynamicHeight={true}>
              {images.carousel.map(img =>(
                <div>
                  <img src={img} />
                </div>
              ))}
            </Carousel>
          </div>
      </Modal>

      <section className="projects" id="projects">
        <div className="wrapper">
          <div className="title">
            <span>PROJECTS</span>
            <hr />
          </div>
          <div className="grid-projects">
            {gallery.map(gal => (
              <div>
                <div className="projects-wallpaper" onClick={() => setModalIsOpen(true)}>
                  <img src={gal.thumbnail} alt="previous project" />
                  <div className="cover" onClick={() => setImages(gal)}>
                    <div className="cover-title">
                      <span className="subtitle">{gal.subtitle}</span>
                      <article>{gal.info}</article>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="contact" id="contact">
        <div className="wrapper">
          <div className="title">
            <span>CONTACT</span>
            <hr />
          </div>

          <div className="grid-contact">
            <div className="contact-left-container">
              <div className="contact-text">
              <span>Have a project in mind?</span>
              <span>Reach out, we’re not far.</span>
              </div>
              <div className="contact-each">
                <div className="contact-icon">
                  <svg height="35" viewBox="0 0 55 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M54.584 0.189497C54.323 0.00149721 53.987 -0.0515026 53.683 0.0524974L35.953 5.9625L19.229 2.0275C19.187 2.0175 19.146 2.0315 19.104 2.0275C18.997 2.0165 18.89 2.0025 18.783 2.0255L0.783 6.0255C0.326 6.1275 0 6.5325 0 7.0015V50.0015C0 50.3055 0.138 50.5915 0.375 50.7815C0.554 50.9255 0.775 51.0015 1 51.0015C1.072 51.0015 1.145 50.9935 1.217 50.9785L19.024 47.0215L35.826 49.9865C35.884 49.9975 35.942 50.0025 36 50.0025C36.121 50.0025 36.24 49.9785 36.352 49.9365C36.355 49.9355 36.359 49.9365 36.362 49.9345L54.362 42.9345C54.747 42.7835 55 42.4135 55 42.0015V1.0015C55 0.679497 54.846 0.378497 54.584 0.189497ZM2 7.8025L18 4.2475V45.1985L2 48.7545V7.8025ZM20 4.2635L35 7.7925V47.8085L20 45.1625V4.2635ZM53 41.3175L37 47.5395V7.7215L53 2.3885V41.3175Z"
                      fill="#DEAC27" />
                  </svg>
                </div>
                <div className="contact-details">
                  <div className="contact-main">Address</div>
                  <div className="contact-sub">DS-One Building Unit 1A, AFP-PNP Housing Village Phase 2, Block 1 Lot 20, Barangay Pinagsama, Taguig City</div>
                </div>
              </div>
              <div className="contact-each">
                <div className="contact-icon">
                  <svg height="43" viewBox="0 0 46 71" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M41.2387 0H4.4949C2.01627 0 0 2.01642 0 4.49505V66.5049C0 68.9834 2.01642 71 4.49505 71H41.2387C43.7173 71 45.7338 68.9836 45.7338 66.5049V4.49505C45.7336 2.01642 43.7173 0 41.2387 0ZM2.25248 11.2978H43.4813V58.2526H2.25248V11.2978ZM4.4949 2.25248H41.2387C42.4752 2.25248 43.4813 3.25844 43.4813 4.49505V9.79619H2.25248V4.49505C2.25248 3.25844 3.25844 2.25248 4.4949 2.25248ZM41.2387 68.7474H4.4949C3.25844 68.7474 2.25233 67.7414 2.25233 66.5048V59.7541H43.4811V66.5048C43.4811 67.7414 42.4752 68.7474 41.2387 68.7474Z"
                      fill="#DEAC27" />
                    <path
                      d="M22.8669 60.7497C20.8329 60.7497 19.1782 62.4045 19.1782 64.4385C19.1782 66.4725 20.833 68.1272 22.8669 68.1272C24.9007 68.1272 26.5555 66.4723 26.5555 64.4385C26.5555 62.4047 24.9009 60.7497 22.8669 60.7497V60.7497ZM22.8669 66.6255C21.6609 66.6255 20.6799 65.6443 20.6799 64.4385C20.6799 63.2325 21.6609 62.2513 22.8669 62.2513C24.0729 62.2513 25.0539 63.2325 25.0539 64.4385C25.0539 65.6443 24.0729 66.6255 22.8669 66.6255Z"
                      fill="#DEAC27" />
                    <path
                      d="M17.7613 7.15461H27.9725C28.3873 7.15461 28.7233 6.81839 28.7233 6.40378C28.7233 5.98917 28.3873 5.65295 27.9725 5.65295H17.7613C17.3465 5.65295 17.0104 5.98917 17.0104 6.40378C17.0104 6.81839 17.3465 7.15461 17.7613 7.15461Z"
                      fill="#DEAC27" />
                    <path
                      d="M15.0587 7.15461C15.2554 7.15461 15.4491 7.07502 15.5888 6.93537C15.7285 6.79421 15.8095 6.602 15.8095 6.40378C15.8095 6.20556 15.7285 6.01335 15.5888 5.8722C15.449 5.73254 15.2553 5.65295 15.0587 5.65295C14.8605 5.65295 14.6681 5.73254 14.5271 5.8722C14.3875 6.01185 14.3079 6.20556 14.3079 6.40378C14.3079 6.602 14.3875 6.79421 14.5271 6.93537C14.6668 7.07502 14.8605 7.15461 15.0587 7.15461Z"
                      fill="#DEAC27" />
                  </svg>
                </div>
                <div className="contact-details">
                  <div className="contact-main">Phone</div>
                  <div className="contact-sub">
                    +63 922 824 9503
                    <br />
                    (02) 8346 8106
                  </div>
                </div>
              </div>
              <div className="contact-each">
                <div className="contact-icon">
                  <svg height="35" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M50.688 48.222C55.232 43.101 58 36.369 58 29C58 21.333 55.004 14.357 50.128 9.166V9.165C50.124 9.159 50.118 9.157 50.115 9.152C45.036 3.753 37.92 0.297 30.005 0.026L30.004 0.025L29.439 0.01C29.293 0.005 29.147 0 29 0C28.853 0 28.707 0.005 28.561 0.01L27.998 0.025L27.997 0.026C20.082 0.297 12.966 3.753 7.887 9.152C7.883 9.157 7.877 9.159 7.874 9.165C7.874 9.165 7.874 9.166 7.873 9.167C2.996 14.357 0 21.333 0 29C0 36.369 2.768 43.101 7.312 48.222C7.318 48.231 7.318 48.241 7.325 48.25C7.343 48.275 7.369 48.287 7.388 48.31C12.494 54.018 19.82 57.695 27.996 57.975L27.997 57.976L28.56 57.991C28.707 57.995 28.853 58 29 58C29.147 58 29.293 57.995 29.439 57.99L30.002 57.975L30.003 57.974C38.188 57.693 45.522 54.009 50.628 48.289C50.641 48.272 50.662 48.267 50.674 48.249C50.682 48.241 50.682 48.231 50.688 48.222ZM2.025 30H14.028C14.141 34.239 14.969 38.358 16.443 42.217C13.599 43.246 10.88 44.626 8.332 46.348C4.585 41.891 2.253 36.21 2.025 30ZM8.878 11.023C11.366 12.641 14.015 13.937 16.778 14.905C15.086 19.012 14.15 23.44 14.028 28H2.025C2.264 21.493 4.812 15.568 8.878 11.023ZM55.975 28H43.972C43.85 23.44 42.914 19.012 41.222 14.905C43.985 13.937 46.634 12.641 49.122 11.023C53.188 15.568 55.736 21.493 55.975 28ZM28 14.963C25.109 14.881 22.271 14.45 19.529 13.68C21.556 9.522 24.418 5.769 28 2.644V14.963ZM28 16.963V28H16.028C16.151 23.652 17.063 19.435 18.694 15.525C21.7 16.396 24.821 16.878 28 16.963ZM30 16.963C33.179 16.878 36.3 16.397 39.307 15.525C40.938 19.435 41.85 23.652 41.973 28H30V16.963ZM30 14.963V2.644C33.582 5.769 36.444 9.522 38.471 13.68C35.729 14.45 32.891 14.881 30 14.963ZM40.409 13.072C38.488 9.047 35.822 5.38 32.521 2.237C38.377 3.003 43.646 5.651 47.704 9.555C45.4 11.017 42.956 12.193 40.409 13.072ZM17.591 13.072C15.044 12.193 12.6 11.017 10.297 9.555C14.354 5.651 19.624 3.003 25.48 2.237C22.178 5.38 19.512 9.047 17.591 13.072ZM16.028 30H28V40.038C24.693 40.126 21.453 40.642 18.339 41.579C16.932 37.924 16.141 34.019 16.028 30ZM28 42.038V55.356C24.166 52.011 21.16 47.947 19.116 43.439C21.983 42.594 24.961 42.124 28 42.038ZM30 55.356V42.038C33.039 42.123 36.017 42.594 38.884 43.438C36.84 47.947 33.834 52.011 30 55.356ZM30 40.038V30H41.972C41.859 34.019 41.068 37.924 39.66 41.58C36.547 40.642 33.307 40.126 30 40.038ZM43.972 30H55.975C55.747 36.21 53.416 41.891 49.668 46.348C47.12 44.626 44.401 43.246 41.557 42.217C43.032 38.358 43.859 34.239 43.972 30ZM9.691 47.846C12.057 46.274 14.576 45.01 17.208 44.065C19.153 48.425 21.945 52.398 25.479 55.763C19.328 54.958 13.823 52.078 9.691 47.846ZM32.521 55.763C36.055 52.399 38.847 48.426 40.792 44.065C43.424 45.01 45.942 46.274 48.309 47.846C44.177 52.078 38.672 54.958 32.521 55.763Z"
                      fill="#DEAC27" />
                  </svg>
                </div>
                <div className="contact-details">
                  <div className="contact-main">Say Hello</div>
                  <div className="contact-sub">
                  deltasierraph@gmail.com
                  <br />
                  dstradingph@gmail.com
                  </div>
                </div>
              </div>
            </div>
            <div className="contact-right-container">
              <form name="contact" method="POST" data-netlify-recaptcha="true" data-netlify="true">
                <input type="hidden" name="form-name" value="contact" />
                <input required type="text" name="name" placeholder="Name" />
                <input required type="email" name="email" placeholder="Email" />
                <textarea required name="message" cols="10" rows="10" placeholder="Message"/>
                <div data-netlify-recaptcha="true"></div>
                <button type="submit">Send Message</button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <section className="footer">
        <div className="wrapper">
          
            <div className="grid-footer">
              
              <div className="footer-right">

                <img src={velux} className="velux" alt="velux" />

                {/* <strong>Social Media</strong>
                <span>Facebook</span>
                <span>Instagram</span>
                <br/>
                <strong>Site Map</strong>
                <span>Home</span>
                <span>Services</span>
                <span>About</span>
                <span>Projects</span>
                <span>Contact</span> */}
              </div>

              <div className="footer-left">
                <span>© 2020 Delta Sierra Construction and Trading Corp.</span>
                <span>Site developed by 
                  <a target="_blank" rel="noopener noreferrer" href="https://design.jinsgonzales.com"> Jins Gonzales Design</a>
                </span>
              </div>

            </div>
        </div>
      </section>
    </div>
  );
}

export default App;
